import { createRouter, createWebHistory } from "vue-router";
import HomePage from "@/views/Home.vue";
import ImpressumPage from "@/views/Impressum.vue";
import ServicesPage from "@/views/ServicesPage.vue";
import AboutUs from "@/views/AboutUs.vue";
import ContactPage from "@/views/ContactPage.vue";
import ServiceDetail from "@/views/services/ServiceDetail.vue";

const routes = [
  {
    path: "/",
    name: "HomePage",
    component: HomePage,
    meta:{title:"Poorent - Car Rental & Tours in Rome",
      description: 'Discover the best car rental services in Rome with Poorent. Explore the Eternal City with our vintage Fiat 500s, Segways, and golf carts.',
      keywords: 'car rental, Rome tours, vintage Fiat 500, segway rental, golf cart rental',
    },
  },
  {
    path: "/impressum",
    name: "ImpressumPage",
    component: ImpressumPage,
    meta:{title: "Poorent - Legal Notice (Impressum)",
      description: "Find the legal information, company details, and contact information for Poorent, your trusted car rental and guided tour provider in Rome.",
      keywords: "Poorent legal notice, Impressum, company details, Rome car rental legal, terms and conditions, business information",},
  },
  {
    path: "/services",
    name: "ServicesPage",
    component: ServicesPage,
    meta:{title: 'Our Services - Poorent',
      description: 'Rent vintage Fiat 500s, Segways, and golf carts for an unforgettable experience in Rome.',
      keywords: 'Fiat 500 rental, segway rental, golf cart rental, tours in Rome',},
  },
  {
    path: "/about-us",
    name: "AboutUs",
    component: AboutUs,
    meta:{ title: 'About Us - Poorent Car Rentals & Tours',
      description: 'Learn more about Poorent, founded by Alireza Keimanesh, offering top-quality vehicle rentals and guided tours in Rome.',
      keywords: 'Rome car rental, tour guide, vintage cars, tourism in Rome',},
  },
  {
    path: "/contact",
    name: "ContactPage",
    component: ContactPage,
    meta:{title: 'Contact Poorent - Rent a Car or Book a Tour',
      description: 'Get in touch with Poorent to rent a car or book a guided tour in Rome.',
      keywords: 'contact car rental, book a tour, Rome travel assistance',},
  },
  {
    path: '/services/:slug',
    name: 'ServiceDetail',
    component: ServiceDetail,
  }

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Update meta tags dynamically
router.afterEach((to) => {
  document.title = to.meta.title || 'Poorent - Car Rentals & Tours in Rome';
  document.querySelector('meta[name="description"]')?.setAttribute('content', to.meta.description || '');
  document.querySelector('meta[name="keywords"]')?.setAttribute('content', to.meta.keywords || '');
});

export default router;
